import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const changeOrderStatus = async (order, status, toRemove) => {
    const changeStatusRes = await HttpClient.post(`/admin/api/orders/${order.eventId}/changeStatus/${status}`, {
        remove: toRemove,
        updatedAt: order.updatedAt
    });

    if (changeStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטאטוס ההזמנה").append(`(${changeStatusRes.error})`).toString()
        );
    } else {
        message.success("סטאטוס ההזמנה שונה בהצלחה");
    }
};

export const updateOrder = async (order, whoToSendUpdateEmail, updatedAt, errorMessage, successMessage) => {
    const response = await HttpClient.safePost(`/admin/api/transactions/updateOrder?updatedAt=${updatedAt}`, {
        order,
        whoToSendUpdateEmail
    });

    if (response?.error) {
        message.error(new StringBuilder(errorMessage, "|").append(response.error).toString());
    } else {
        if (successMessage) {
            message.success(successMessage);
        }
    }

    return response;
};

export const createOrderIssueLog = async issueData => {
    const response = await HttpClient.safePost(`/admin/api/orders/createIssueLog`, issueData);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה ביצירת דיווח תקלה").append(`(${response.error})`).toString());
    } else {
        message.success("דיווח התקלה נוסף בהצלחה");
    }

    return response;
};

export const updateOrderIssueLog = async issueData => {
    const response = await HttpClient.safePut(`/admin/api/orders/updateIssueLog`, issueData);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעדכון תקלה").append(`(${response.error})`).toString());
    } else {
        message.success("התקלה עודכנה בהצלחה");
    }

    return response;
};

export const sendReminderToProvider = async order => {
    const response = await HttpClient.post(`/admin/api/events/${order.eventId}/sendReminderToProvider`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת שליחת תזכורת לספק").append(`(${response.error})`).toString());
    } else {
        message.success("התזכורת נשלחה לספק בהצלחה");
    }

    return response;
};

export const reviewNoDriver = async order => {
    const response = await HttpClient.post(`/admin/api/events/${order.eventId}/reviewNoDriver`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת סקירת ההזמנה ללא נהג").append(`(${response.error})`).toString());
    } else {
        message.success("ההזמנה ללא נהג נסקרה בהצלחה");
    }

    return response;
};

export const reviewDecline = async order => {
    const response = await HttpClient.post(`/admin/api/events/${order.eventId}/reviewDecline`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת טיפול בהזמנה שנדחתה").append(`(${response.error})`).toString());
    } else {
        message.success("ההזמנה שנדחתה טופלה בהצלחה");
    }
};

export const reviewBadRating = async order => {
    const response = await HttpClient.post(`/admin/api/events/${order.eventId}/reviewBadRating`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת טיפול בדירוג השלילי").append(`(${response.error})`).toString());
    } else {
        message.success("הדירוג השלילי טופל בהצלחה");
    }

    return response;
};
